var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagingNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(0.5)",
    fill: "white",
    fillOpacity: 0.01
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(4.5 4)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.495 14.9951C19.6825 15.1826 19.7878 15.4369 19.7878 15.7021C19.7878 15.9672 19.6825 16.2215 19.495 16.4091L14.902 21.0021C14.7157 21.1846 14.4649 21.2863 14.2041 21.285C13.9432 21.2837 13.6935 21.1795 13.509 20.995C13.3246 20.8106 13.2204 20.5608 13.2191 20.3C13.2178 20.0392 13.3194 19.7884 13.502 19.6021L17.402 15.7021L13.502 11.8021C13.3194 11.6158 13.2178 11.365 13.2191 11.1041C13.2204 10.8433 13.3246 10.5935 13.509 10.4091C13.6935 10.2247 13.9432 10.1205 14.2041 10.1192C14.4649 10.1178 14.7157 10.2195 14.902 10.4021L19.495 14.9951Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagingNext);
export default __webpack_public_path__ + "static/media/pagingNext.c002800099dc620bbf941442a21902c3.svg";
export { ForwardRef as ReactComponent };